import React from "react";
export default function SupplierProgram() {
  return (
    <div className="section borderLight">
      <h2>SupplierProgram</h2>
      <p>Coming soon</p>
    </div>
  );
}
